import request from '../../utils/request'
import config from '../../../config/config'
// const baseURL = 'http://localhost:3013'
const baseURL = config.baseUrl;

//  信息新增
export function vipsAdd (data) {
  return request({
    url: baseURL + 'vips/add',
    method: 'post',
    data: data
  })
}
//  信息查询
export function vipsList (data) {
  return request({
    url: baseURL + 'vips/list',
    method: 'post',
    data: data
  })
}
//  信息删除
export function vipsDelete (data) {
  return request({
    url: baseURL + 'vips/delete',
    method: 'post',
    data: data
  })
}
//  信息删除
export function vipsUpdate (data) {
  return request({
    url: baseURL + 'vips/update',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/vips/index.js